<div class="flex-row gap-8">
  @if (type() === 'icon') {
    <vl-chips cursor="default" size="small" state="active" iconColor="var(--color-on-warning)" iconLeft="fiber_manual_record" matTooltip="Enregistrement en cours..."/>
  } @else if (type() === 'button') {
    <vl-chips [cursor]="ticketService.recording() ? 'default' : 'pointer'"
              [state]="ticketService.recording() ? 'active' : 'enabled'"
              (action)="ticketService.startRecording()"
              iconColor="var(--color-on-warning)"
              iconLeft="fiber_manual_record"
              [matTooltip]="'logs_ui.enregistrement_info' | trans">
      <span class="body-2">
        @if (ticketService.recording()) {
          {{ 'logs_ui.enregistrement_en_cours' | trans }}
        } @else {
          Enregistrer ma session
        }
      </span>
    </vl-chips>
  }
  @if (ticketService.recording()) {
    <vl-chips [size]="type() == 'button' ?  'big' : 'small'" iconLeft="stop" [matTooltip]="'logs_ui.arreter_enregistrement' | trans" (action)="ticketService.stopRecording()"/>
  }
</div>
